import { metaContent } from './metaContent';

// The browser reporter only configures itself when the layout renders a
// `honeybadger-api-key` meta tag, which needs HONEYBADGER_API_KEY set.
// Production does not set it, so the library was being downloaded by every
// visitor and never used — hence the dynamic import. The server-side
// honeybadger gem is a separate thing and is untouched.
const honeybadgerApiKey = metaContent('honeybadger-api-key');

if (honeybadgerApiKey) {
  import('@honeybadger-io/js').then(({ default: Honeybadger }) => {
    Honeybadger.configure({
      apiKey: honeybadgerApiKey,
      environment: 'production',
      revision: metaContent('git-commit-version'),
    });
  });
}
